import DirectedAcyclicGraph from './engine/DirectedAcyclicGraph';
import SignUpScreens from './SignUpScreens';

export default class SignUpGraph extends DirectedAcyclicGraph {
	constructor(nodes = [], transitions = [], options = {}) {
		super(nodes, transitions, options);
	}

	addNode(nodeName) {
		if (!SignUpScreens[nodeName]) {
			return this._missingSignUpScreenError(nodeName);
		}

		super.addNode(nodeName);
	}

	_missingSignUpScreenError(nodeName) {
		if (!this.options.quiet) {
			throw new Error(
				`SignUpGraph MissingSignUpScreenError\n '${nodeName}' is missing from SignUpScreens`
			);
		}
	}
}
